<template src="./templates/TopLevelCategories.html" />

<script setup>

import {
    useCategoriesStore,
} from '@timezoneone/dottie-client-jam';

import IconRenderer from './IconRenderer.vue';

const categoriesStore = useCategoriesStore();

/* eslint-disable func-names */
const topLevelCategoryClick = function(event) {

    /*
    Top-level categories are checkboxes, rather than radio buttons, so we have to add
    this function to make it possible to only select one at a time
    */

    const input = event.target.closest('.js-category-filter').getElementsByTagName('input')[0];

    if (input.checked) {

        const inputs = document.getElementsByClassName('js-top-level-category');

        for (let i = 0; i < inputs.length; i++) {

            if (inputs[i] !== input) {

                inputs[i].checked = false;

            }

        }

        categoriesStore.setChosenTopLevelCategory(input.id);

        return;

    }

    categoriesStore.setChosenTopLevelCategory('');

};

</script>
